module.exports = __webpack_public_path__ + "static/img/son1_active.ddc76ac4.png";